var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 3,
    fill: "#0077B5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9399 9.00002C10.9397 9.53046 10.7287 10.0391 10.3534 10.4139C9.97819 10.7888 9.46937 10.9993 8.93894 10.999C8.40851 10.9988 7.89991 10.7878 7.52502 10.4125C7.15014 10.0373 6.93968 9.52846 6.93994 8.99802C6.94021 8.46759 7.15117 7.95899 7.52644 7.5841C7.9017 7.20922 8.41051 6.99876 8.94094 6.99902C9.47137 6.99929 9.97998 7.21026 10.3549 7.58552C10.7297 7.96078 10.9402 8.46959 10.9399 9.00002ZM10.9999 12.48H6.99994V25H10.9999V12.48ZM17.3199 12.48H13.3399V25H17.2799V18.43C17.2799 14.77 22.0499 14.43 22.0499 18.43V25H25.9999V17.07C25.9999 10.9 18.9399 11.13 17.2799 14.16L17.3199 12.48Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.cb3b7c668e811f059421292cdacd6fc8.svg";
export { ForwardRef as ReactComponent };